var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"🖥️-Desktop","stroke":"inherit","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinejoin":"bevel"},React.createElement("g",{"id":"6.3-Solutions->-Construction","transform":"translate(-226.000000, -3794.000000)","strokeWidth":"2"},React.createElement("g",{"id":"links/arrows/arrow-right/right-green","transform":"translate(226.000000, 3795.000000)"},React.createElement("g",{"id":"arrow-left-copy","transform":"translate(22.000000, 19.000000) scale(-1, 1) translate(-22.000000, -19.000000) "},[React.createElement("line",{"x1":"44","y1":"18.6090535","x2":"0","y2":"18.6090535","id":"Path","key":0}),React.createElement("polyline",{"id":"Path","points":"18.7234043 38 0 18.6090535 18.7234043 0","key":1})])))));
}

ArrowRight.defaultProps = {"width":"45px","height":"40px","viewBox":"0 0 45 40","version":"1.1"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
